import React, { useRef, useState, useEffect, useMemo} from 'react';
import { CButton } from '@coreui/react'


const Fiesta = () => {

  return (
    <div style={{"text-align": "center", "padding": "4rem 2rem 4rem 2rem", "height":"fit-content", "maxHeight": "fit-content", backgroundColor: "#1f2a4e"}}>
        <div className="header-seccion">
          <h1 className='blanco bold'>
            Guía para una fiesta épica🤍🪩
        </h1>
        <p className="text-lg blanco"> ¡Queremos que la fiesta sea tan tuya como nuestra👰🤵!</p>
        </div>
        
        <p className='text-md blanco'>
            💃🕺
            <br></br>
            Ayúdanos a armar el ambiente <a href='https://open.spotify.com/playlist/0bZ3jdmICP5fdYiAjSVrJX?si=f4981c40b1a04e7f&pt=bc826f437dd479d078453039d583f593' target='_blank'>añadiendo a la playlist LA canción</a> que te llevará sí o sí a la pista. Se vale de todo para bailar, hasta botargas (sí, de verdad). 
            <br></br><br></br>
            🍾
            <br></br>
            Tendremos una reserva de alcohol lista para el brindis inicial, pero si tienes algún gusto especial o deseas beber un poco más, siéntete libre de traer el trago de tu preferencia. 
            <br></br><br></br>
            🍽️
            <br></br>
            Queremos que todos disfruten de la comida tanto como nosotros. El servicio será estilo buffet, pero nos importa mucho tu bienestar. Si tienes alguna alergia alimentaria severa o restricción especial, por favor háznoslo saber cuanto antes para asegurarnos de tener opciones seguras y deliciosas para ti.
            <br></br><br></br>
            ⚠️
            <br></br>
            Te recordamos que por motivos de seguridad (y tranquilidad) de nuestros invitados, este es un evento sólo para adultos.
            <br></br><br></br>
            💬
            <br></br>
            ¡Contacta a los novios en caso de tener alguna duda o imprevisto! Estaremos felices de ayudar.
            <br></br><br></br>
            🌙🌲✨
            <br></br>
            ¡Nosotros ponemos el bosque y tú pones la chispa para una noche inolvidable!
        </p>
        <div className="spotify-cont">
          <iframe data-testid="embed-iframe" style={{"border-radius":"12px"}} src="https://open.spotify.com/embed/playlist/0bZ3jdmICP5fdYiAjSVrJX?utm_source=generator&theme=0"  frameBorder="0"  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
        </div>
        
    </div>
  );
};

export default Fiesta;